function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "iconsGradient"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#710d22"
}), React.createElement("stop", {
  offset: "50%",
  stopColor: "#ae1333"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#e64b4b"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M518.516,422.608h99c83-45.601,114.101-127.9,125-170.2c3.7-14.5-5.899-28.9-20.7-31c-128.699-18.5-193.5,17.4-239,89.6 c3.2,7.601,6.301,15.3,9.301,23.101c6.899,18.3,11.399,40,13.6,60.6c62.3-35.4,116.1-80.1,135.4-92.9 C627.016,317.208,588.117,364.808,518.516,422.608z"
}), React.createElement("path", {
  d: "M0.417,135.908c11.1,59.7,55.3,219.2,217.5,286.7h194.3c-61.4-111.9-172.4-166.9-222-197.3c37.8,6.9,154.7,47,261.3,158.1 c8.2,8.6,24.9,26.7,25.4,26.5c-12.101-175-174.3-316.9-345.801-316.9c-34.899,0-72.199,4.5-112,14.1 C6.216,110.208-1.984,122.908,0.417,135.908z"
}), React.createElement("path", {
  d: "M937.816,477.608c0-13.801-11.199-25-25-25h-770.7c-13.8,0-25,11.199-25,25v3c0,201.199,163.101,364.199,364.2,364.199 h92.2c201.2,0,364.2-163.1,364.2-364.199v-3H937.816z"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var _ref18 =
/*#__PURE__*/
React.createElement("g", null);

var SvgAcompanhamentos = function SvgAcompanhamentos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "937.816px",
    height: "937.815px",
    viewBox: "0 0 937.816 937.815",
    style: {
      enableBackground: "new 0 0 937.816 937.815"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAcompanhamentos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/acompanhamentos.b4e84c01.svg";
export { ForwardRef as ReactComponent };